var
    symbols = require('../utils/symbols'),
    Square = require('../core/Square'),
    Diagonal =  require('./Diagonal'),
    RafleItem = require('./RafleItem'),
    Move = require('../core/Move'),
    NTree = require('./NTree'),
    Piece = symbols.Piece,
    DraughtsTypes = symbols.DraughtsTypes8x8
;


function PathFinder() {
}

PathFinder.prototype.getSimpleMovements = function(board, startingSquareNum) {
    let moves = []; // [Move]

    // Récupération des 2 diagonales
    let diagoGD = this._getDiagonalGD(board, startingSquareNum);
    let diagoTT = this._getDiagonalTT(board, startingSquareNum);

    // Déplacements simples (observés sur chacune des 2 diagonales)
    let list = diagoGD.getSimpleMovements(startingSquareNum);
    list = list.concat(diagoTT.getSimpleMovements(startingSquareNum));
    const checkersRelated = (board.getDraughtsType() === DraughtsTypes.CHECKERS || board.getDraughtsType() === DraughtsTypes.ITALIAN);
    for (let k = 0; k < list.length; k++) {
        let endingSquareNum = list[k];
        let move = new Move(startingSquareNum, endingSquareNum);
        if (checkersRelated) {
            if (Math.abs(diagoGD.indexOf(startingSquareNum) - diagoGD.indexOf(endingSquareNum)) == 1 ||
                Math.abs(diagoTT.indexOf(startingSquareNum) - diagoTT.indexOf(endingSquareNum)) == 1) {
                    moves.push(move);        
                }
        } else {
            moves.push(move);
        }
    }

    return moves;
};




PathFinder.prototype.getRafleMovements = function(board, startingSquareNum) {
    let tree = this.getTreeRafles(board, startingSquareNum); // NTree<RafleItem>
    return this._treeToMovements(board, tree);
};

PathFinder.prototype._treeToMovements = function(board, tree) {
    let lists = tree.traverse(); // [[RafleItem]]

    let moves = []; // [Move]

    for (let k = 0; k < lists.length; k++) {
        let list = lists[k];

        // First item is not a capture but the starting point.
        // (It still exists even if there is no capture)
        if (list.length > 1) {
            let riStart = list[0];
            let riEnd = list[list.length - 1];

            let nStart = riStart.endingSquareNum;
            let nEnd = riEnd.endingSquareNum;
            let move = new Move(nStart, nEnd);

            for (let j = 0; j < list.length; j++) {
                let ri = list[j];

                // Starting square is not considered as a landing square
                // unlike the final square (it can be the same).
                if (ri.endingSquareNum !== nStart || j !== 0){
                    move.addLandingSquareNum(ri.endingSquareNum);
                }
                if (ri.capturedSquareNum != null) {
                    let capturedSq = new Square(ri.capturedSquareNum, board.getPiece(ri.capturedSquareNum));
                    move.addCapturedSquare(capturedSq);
                }
            }
            moves.push(move);
        }
    }
    return moves;
};

PathFinder.prototype.getTreeRafles = function(board, startingSquareNum) {
    let ri = new RafleItem(startingSquareNum);

    let ntreeRoot = new NTree();
    ntreeRoot.setItem(ri);

    this.buildRafles(board.clone(), ntreeRoot, []);

    return ntreeRoot;
};

PathFinder.prototype.buildRafles = function(board, node, numSquaresPrevCaptured) {
    // board.debugDraughtBoard();

    let ri = node.getItem();
    let numSquareNewStart = ri.getNumber();
    // console.log("");
    // console.log("buildRafles(" + numSquareNewStart + ", [" + numSquaresPrevCaptured + "])");

    // Récupération des 2 diagonales
    let diagoGD = this._getDiagonalGD(board, numSquareNewStart);
    let diagoTT = this._getDiagonalTT(board, numSquareNewStart);

    // debug
    // console.log(diagoGD);
    // console.log(diagoTT);
    // ---

    // Liste des prises unitaires (observées sur chacune des 2 diagonales)
    let list = diagoGD.getRaflesItem(numSquareNewStart, numSquaresPrevCaptured);
    list = this._filterRaflesList(board, list, numSquareNewStart, diagoGD);
    let list2 = diagoTT.getRaflesItem(numSquareNewStart, numSquaresPrevCaptured);
    list2 = this._filterRaflesList(board, list2, numSquareNewStart, diagoTT);
    list = list.concat(list2);

    // Ajout de ces rafles simples dans l'arbre.
    node.setChildren(list);

    // Recommencer recursivement sur les rafles filles.
    let childrenNodes = node.getChildrenNodes();
    for (let k = 0; k < childrenNodes.length; k++) {
        let nf = childrenNodes[k];
        let r = nf.getItem();

        // On met à jour la liste des cases déjà prises.
        let lcdp = numSquaresPrevCaptured.slice(0);
        lcdp.push(r.capturedSquareNum);
        // ---

        // On deplace le pion avant de poursuivre
        // (sans retirer la pièce prise).
        let diag = board.clone();
        let numStart = ri.getNumber();
        let numEnd = r.endingSquareNum;
        let startSq = diag.getSquare(numStart);
        let piece = startSq.piece;
        diag.getSquare(numStart).piece = Piece.EMPTY;

        switch (board.getDraughtsType()) {
            case DraughtsTypes.BRAZILIAN:
                diag.getSquare(numEnd).piece = piece;
            break;
            case DraughtsTypes.RUSSIAN:
                if (board.checkIsPromoteField(piece, numEnd)) {
                    if (piece == Piece.PAWN_WHITE) {
                        diag.getSquare(numEnd).piece = Piece.DAME_WHITE;
                    } else if (piece == Piece.PAWN_BLACK) {
                        diag.getSquare(numEnd).piece = Piece.DAME_BLACK;
                    }
                } else {
                    diag.getSquare(numEnd).piece = piece;
                }
            break;
            default:
                diag.getSquare(numEnd).piece = piece;
            break;
        }
        
        // ---
        this.buildRafles(diag, nf, lcdp);
    }
    return this;
};

PathFinder.prototype._filterRaflesList = function(board, list, squareStart, diagonal) {
    let result = [];
    const pieceSrc = board.getPiece(squareStart);
    const srcIdx = diagonal.indexOf(squareStart);
    for (let i = 0; i<list.length; i++) {
        const rafleItem = list[i];
        const capturedIdx = diagonal.indexOf(rafleItem.capturedSquareNum);
        const endingIdx = diagonal.indexOf(rafleItem.endingSquareNum);
        const pieceDest = board.getPiece(rafleItem.capturedSquareNum);
        switch (board.getDraughtsType()) {
            case DraughtsTypes.CHECKERS:
                if (Math.abs(srcIdx - endingIdx) == 2) {
                    result.push(list[i]);
                }
            break;
            case DraughtsTypes.ITALIAN:
                if (Math.abs(srcIdx - endingIdx) == 2) {
                    let push = true;
                    if (pieceSrc === Piece.PAWN_WHITE && pieceDest === Piece.DAME_BLACK) {
                        push = false;
                    }
                    if (pieceSrc === Piece.PAWN_BLACK && pieceDest === Piece.DAME_WHITE) {
                        push = false;
                    }
                    if (push) {
                        result.push(list[i]);
                    }
                }
            break;
            default:
                result.push(list[i]);
            break;
        }
        
    }
    
    return result;
}

PathFinder.prototype.displayTreePaths = function(tree) {
    let lists = tree.traverse(); // [[RafleItem]]

    console.log("Nombre de mouvements : " + lists.length);
    for (let k = 0; k < lists.length; k++) {
        let list = lists[k];
        let s = "";
        for (let j = 0; j < list.length; j++) {
            let ri = list[j];
            s += " > " + ri.endingSquareNum + "[" + ri.capturedSquareNum + "]";
        }
        console.log(s);
    }
};

PathFinder.prototype._getDiagonal = function(diagonalsArr, board, number) {
    let diag = [];
    loop:
    for (let i = 0; i < diagonalsArr.length; i++) {
        let diagonal = diagonalsArr[i];
        for (let j = 0; j < diagonal.length; j++) {
            if (diagonal[j] === number) {
                diag = diagonal;
                break loop;
            }
        }
    }
    const checkersRelated = (board.getDraughtsType() === DraughtsTypes.CHECKERS || board.getDraughtsType() === DraughtsTypes.ITALIAN);
    const square = board.getSquare(number);
    let diago = new Diagonal(true);
    for (let i = 0; i < diag.length; i++) {
        let c = board.getSquare(diag[i]);
        if (checkersRelated) {
            if (square.piece === Piece.PAWN_WHITE) {
                if (diag[i] <= number) {
                    diago.addSquare(c);
                }
            } else if (square.piece === Piece.PAWN_BLACK) {
                if (diag[i] >= number) {
                    diago.addSquare(c);
                }
            } else {
                diago.addSquare(c);
            }
        } else {
            diago.addSquare(c);
        }
    }

    return diago;
}
/** Retourne la diagonaleGD contenant une case donnée. */
PathFinder.prototype._getDiagonalGD = function(board, number) {
    return this._getDiagonal(board.conf['DIAGONALS_GD'], board, number);
};

/** Retourne la diagonaleTT contenant une case donnée. */
PathFinder.prototype._getDiagonalTT = function(board, number) {
    return this._getDiagonal(board.conf['DIAGONALS_TT'], board, number);
};


module.exports = PathFinder;



// WEBPACK FOOTER //
// ./src/board/brain/PathFinder.js